/**
 * Formatting helpers for the public site.
 */

const REL_TIME = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
const UNITS = [
  ["year", 365 * 24 * 60 * 60 * 1000],
  ["month", 30 * 24 * 60 * 60 * 1000],
  ["day", 24 * 60 * 60 * 1000],
  ["hour", 60 * 60 * 1000],
  ["minute", 60 * 1000],
  ["second", 1000],
];

export function formatRelativeTime(date) {
  if (!date) return "";
  const target = typeof date === "string" ? new Date(date) : date;
  const diff = target.getTime() - Date.now();
  for (const [unit, ms] of UNITS) {
    if (Math.abs(diff) >= ms || unit === "second") {
      return REL_TIME.format(Math.round(diff / ms), unit);
    }
  }
  return "";
}

export function formatDate(date, opts = { dateStyle: "long" }) {
  if (!date) return "";
  const target = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("en-AU", opts).format(target);
}

export function formatPrice(value) {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDirection(value) {
  if (!value) return "";
  return value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
